module.exports = __webpack_public_path__ + "assets/img/pay_page_sample_and_size.fc0a492.png";


//////////////////
// WEBPACK FOOTER
// ./website/assets/pay_page_sample_and_size.png
// module id = a5BF
// module chunks = 50